import { reaction } from 'mobx';
import { useSyncExternalStore } from 'react';

import { userStore } from '@/stores/user.store';

const subscribeToInternalUser = (onStoreChange: () => void) =>
  reaction(() => userStore.isInternalUser, onStoreChange);

const getInternalUser = () => userStore.isInternalUser;

/**
 * `userStore.isInternalUser` as a React value. It flips at runtime when an
 * internal user hides internal tools, so hooks and memoized code need it as a
 * dependency; MobX observer components can read the store directly
 */
export const useIsInternalUser = (): boolean =>
  useSyncExternalStore(subscribeToInternalUser, getInternalUser);
